import { StudentData, StudentValidationError } from '@/types/student-data';

const validateEmail = (email: string): boolean => {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(email);
};

const standardPattern = /^[-A-Za-z\s'\u0590-\u05FF\u00C0-\u00FF\u0100-\u01FF\u0200-\u02AF]+$/;
const googlePattern = /^[-A-Za-z0-9\s'\u0590-\u05FF\u00C0-\u00FF\u0100-\u01FF\u0200-\u02AF]+$/;

const isValidName = (name: string, isGoogle?: boolean): boolean => {
  const pattern = isGoogle ? googlePattern : standardPattern;
  return pattern.test(name);
};

const isWithinLength = (name: string, maxLength: number): boolean => {
  return name.length <= maxLength;
};

export const validateFirstName = (
  firstName: string,
  isGoogle?: boolean
): StudentValidationError | null => {
  if (!firstName) {
    return { field: 'firstName', message: 'first_name_missing' };
  }

  if (!isValidName(firstName, isGoogle)) {
    return { field: 'firstName', message: 'first_name_incorrect' };
  }

  if (!isGoogle && !isWithinLength(firstName, 30)) {
    return { field: 'firstName', message: 'first_name_too_long' };
  }

  return null;
};

export const validateLastName = (
  lastName: string,
  isGoogle?: boolean
): StudentValidationError | null => {
  if (!lastName) {
    return { field: 'lastName', message: 'last_name_missing' };
  }

  if (!isValidName(lastName, isGoogle)) {
    return { field: 'lastName', message: 'last_name_incorrect' };
  }

  if (!isGoogle && !isWithinLength(lastName, 40)) {
    return { field: 'lastName', message: 'last_name_too_long' };
  }

  return null;
};

const ValidateStudent = (student: StudentData): StudentValidationError[] => {
  const errors: StudentValidationError[] = [];

  const firstNameValidation = validateFirstName(student.firstName);
  if (firstNameValidation) {
    errors.push(firstNameValidation);
  }

  const lastNameValidation = validateLastName(student.lastName);
  if (lastNameValidation) {
    errors.push(lastNameValidation);
  }

  if (!student.email || !validateEmail(student.email)) {
    errors.push({ field: 'email', message: 'email_incorrect' });
  }

  return errors;
};

export default ValidateStudent;
